var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "4px",
    viewBox: "0 0 16 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08_Icons/01_Control-16x16/options_nb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-Management---Dealer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Users-List_1920px",
    transform: "translate(-1688.000000, -305.000000)",
    fill: "#363B49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08_Icons/01_Control-16x16/options_nb",
    transform: "translate(1688.500000, 305.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,3 C2.32842712,3 3,2.32842712 3,1.5 C3,0.671572875 2.32842712,0 1.5,0 C0.671572875,0 0,0.671572875 0,1.5 C0,2.32842712 0.671572875,3 1.5,3 Z M7.5,3 C8.32842712,3 9,2.32842712 9,1.5 C9,0.671572875 8.32842712,0 7.5,0 C6.67157288,0 6,0.671572875 6,1.5 C6,2.32842712 6.67157288,3 7.5,3 Z M13.5,3 C14.3284271,3 15,2.32842712 15,1.5 C15,0.671572875 14.3284271,0 13.5,0 C12.6715729,0 12,0.671572875 12,1.5 C12,2.32842712 12.6715729,3 13.5,3 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/options-icon.7d7c48b4033225630847fec91d1d67b8.svg";
export { ForwardRef as ReactComponent };